import { Switch } from "@headlessui/react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

// USED WITH FORMIK

export default function PMSwitch(props) {
  const {
    label,
    hideLabel,
    ariaLabel,
    name,
    values,
    onChange,
    setFieldValue,
    ...other
  } = props;

  const checked =
    values && Object.prototype.hasOwnProperty.call(values, name)
      ? values[name]
      : props.checked;

  const handleChange = (checked) => {
    if (onChange) {
      onChange({
        target: {
          name: name,
          checked: checked,
        },
      });
    }

    if (setFieldValue) {
      // Use the value from Headless UI (authoritative), not !values[name] (stale closure risk).
      setFieldValue(name, checked);
    }
  };

  const showLabel = !hideLabel && label != null && label !== "";
  const toggle = (
    <Switch
      disabled={props.disabled}
      type="checkbox"
      name={name}
      checked={checked}
      onChange={handleChange}
      aria-label={
        showLabel ? undefined : ariaLabel || (typeof label === "string" ? label : name)
      }
      // Promang component kit — PROMANG_COMPONENTS.md §3 Toggles (pm-switch in index.css)
      className={classNames(
        "pm-switch",
        checked ? "is-on" : "",
        props.disabled ? "is-disabled" : ""
      )}
    >
      <span aria-hidden="true" className="pm-switch__knob" />
    </Switch>
  );

  // Design toggle row: label (+ optional description) left, switch right.
  if (props.variant === "row") {
    return (
      <Switch.Group as="div" className="pm-toggle-row">
        <span className="min-w-0 flex-1">
          {showLabel ? (
            <Switch.Label as="span" className="pm-toggle-row__label">{label}</Switch.Label>
          ) : null}
          {props.description ? (
            <Switch.Description as="span" className="pm-toggle-row__description">{props.description}</Switch.Description>
          ) : null}
        </span>
        {toggle}
      </Switch.Group>
    );
  }

  return (
    <Switch.Group as="div" className="flex items-center">
      {toggle}
      {showLabel ? (
        <Switch.Label as="span" className="ml-3">
          <span className="text-sm font-medium" style={{ color: "var(--pls-fg)" }}>{label}</span>
        </Switch.Label>
      ) : null}
    </Switch.Group>
  );
}
